module.exports = __webpack_public_path__ + "img/patient-landing-intro.ee987877.svg";